import { googleAnalytics } from '@/lib/util/googleAnalytics';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export interface UseGoogleAnalyticsOptions {
  ga4key: string,
}

export const useGoogleAnalytics = (options: UseGoogleAnalyticsOptions) => {
  const router = useRouter();

  const logPageView = () => {
    const identityRaw = localStorage.getItem('.storage.identity');
    const identity = identityRaw ? JSON.parse(identityRaw) : {};

    const props = {
      layout: Cookies.get('sw_result_layout'),
      subscriber_status: identity?.details?.subscriber_status || '',
      user_id: identity?.uid || '',
    };

    googleAnalytics.logPageView(props);
  };

  useEffect(() => {
    googleAnalytics.initialize(options.ga4key);
    logPageView();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ options.ga4key ]);

  useEffect(() => {
    // Listen for page changes on navigation changes or when the query changes
    router.events.on('routeChangeComplete', logPageView);
    return () => {
      router.events.off('routeChangeComplete', logPageView);
    };    
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ router.events ]);
};
